import React, { useEffect, useState } from 'react';
import {
  createVideoRelationByCourse,
  // getAlltestModuless,
  // getAlltestModulessSubModules,
  getAllVideoonlySubmodules,
  getAllVideoRelationByCourse,
} from '../../../../service/admin/adminVideoes.service';
import MultiSearchableSelect from '../../../../components/form/MultiSearchableSelect';
import { SubmitHandler, useForm } from 'react-hook-form';
import formValidationRules from '../../../../helpers/formvalidationRules';
import FormButton from '../../../../components/button/FormButton';
import { toast } from 'react-toastify';
import {
  createTestSeriesRelationByCourse,
  getAllTestModulesByCourse,
  getAllTestSeriesModules,
  getAllTestSeriesSubModules,
} from '../../../../service/admin/adminTestSeries.service';
import { buildTree } from '../../../../components/tree/treeUtils';
import Loaders from '../../../../components/loaders/Loaders';
import { TreeMain } from '../../../../components/tree/TreeMain';
export default function AdminCourseTestSeriesRelation(props: { id: string }) {
  const [fetchAllList, setFetchList] = useState([]);
  const [fetchSubModuleList, setFetchSubModuleList] = useState<any>([]);
  const [defaultList, setDefaultList] = useState<any>([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedSubModules, setSelectedSubModules] = useState([]);
  const [onlySubModules, setOnlySubModules] = useState<any>([]);
  const [allOnlySubModules, setAllOnlySubModules] = useState<any>([]);
   const [treeData, setTreeData] = useState<any>([]);
    const [preSelectedIds, setPreSelectedIds] = useState<any>([]);

  const [loading, setLoading] = useState(false);

  const fetchModuleData = async () => {
    let get: any = await getAllTestSeriesModules();
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({ value: item.id, label: item.name });
      });
      console.log("fetcjAll", data)
      setFetchList(data);
    }
  };
 
  const fetchSubModuleData = async (id: string) => {
    console.log("Step2")
    let get: any = await getAllTestSeriesSubModules(id);
    if (get?.status === 'success') {
      let data: any = [];
      let newData:any = [];
      get.message.map((item: any) => {
        data.push({
          id: item.id,
          name: item.name,
          fk_videoModule_id: item.fk_testModule_id,
          fk_videosubmodule_id: item.fk_dir_id,
          types: item.test_type === 1 ? 'dir' : 'file',
          
        });
        newData.push({
          value: item.id,
          label: item.name,
          mod: item.fk_testModule_id,
        });
      });

      // Merge with existing submodules, avoiding duplicates
      const mergedArray = [
        ...fetchSubModuleList,
        ...newData.filter(
          (newItem: any) =>
            !fetchSubModuleList.some(
              (existingItem: any) => existingItem.value === newItem.value
            )
        ),
      ];

      // setFetchSubModuleList(mergedArray);
      setDefaultList((prevList:any) => [...prevList, ...mergedArray]);

      const treeData = buildTree(data);
      console.log(treeData) 
      console.log(fetchAllList)
      setFetchSubModuleList((prev: any[]) => {
        console.log("s1") 
        console.log(fetchAllList)
        const newModule: any = fetchAllList.find((i: any) => i.value === id);
        if (!newModule) return prev;
      
        const updated = [...prev];
        const index = updated.findIndex((item) => item.module === newModule.label);
      
        const newEntry = {
          module: newModule.label,
          treeData: treeData
        };
      
        if (index > -1) {
          // Replace existing
          updated[index] = newEntry;
        } else {
          // Add new
          updated.push(newEntry);
        }
      
        return updated;
      });
      setLoading(false);
    }
    setLoading(false);
  };

  const getSelectedData = async (id: string) => {
    let get: any = await getAllTestModulesByCourse(id);
    if (get?.status === 'success') {
      if (get?.message.length > 0) {
        let getmod: string[] = [];
        let selectedSub: any = [];
        let selesub: any = [];
        let onlySub: any = [];
        let sendMesage:any = [];
        let activeMods:any = [];
        get?.message.map((e: any) => {
          sendMesage.push(
            e?.testSubModules?.id
          )
          activeMods.push(e.fk_testModules_id)
          getmod.push(e.fk_testModules_id);
          selectedSub.push(e.fk_testSubModules_id);
          if (e.testModules?.testSubModule?.length > 0) {
            e.testModules.testSubModule.map((it: any) => {
              selesub.push({
                label: it.name,
                value: it.id,
                mod: e.fk_testModules_id,
              });
            });
          }
          if (e.fk_testSubModules_id === null) {
            onlySub.push(e?.testSubModules?.id);
          }
        });
        const uniqMod:any = [...new Set(activeMods)];
        console.log("uniqMod")
        console.log(uniqMod)
         setSelectedModules(uniqMod);
        for(let i=0;i<uniqMod.length;i++){
         await fetchSubModuleData(uniqMod[i])
        }
        let uniPreSelectedId = [...new Set(sendMesage)]
        setPreSelectedIds(uniPreSelectedId)
      }
    }
  };
  useEffect(() => {
    fetchModuleData();
    // fetchOnlySubmodules();
  }, [props.id]);
  
  useEffect(() => {
    if (fetchAllList.length > 0) {
      getSelectedData(props.id);
    }
  }, [fetchAllList, props.id]);

  const { handleSubmit, control } = useForm<any>({
    values: {
      modules: selectedModules ? selectedModules : [],
      sub_modules: selectedSubModules ? selectedSubModules : [],
    },
  });

  const onSubmit: SubmitHandler<any> = async (data: any) => {
    setLoading(true);
    let sendingData: any = [];
    let selectedSub:any = [];
    if (treeData.length > 0) {
      treeData.map((e: any) => {
        console.log("All submof")
        console.log(defaultList)
        console.log(defaultList.length)
        let filter: any = defaultList.filter((i: any) => i.value === e.id);
        if (filter.length > 0) {
          sendingData.push({
            fk_course_id: props.id,
            fk_testModules_id: filter[0].mod,
            fk_testSubModules_id: filter[0].value,
          });
          selectedSub.push(
            filter[0].value
          )
        }
      });
    }
   
    console.log("sending data")
    console.log(sendingData)
    if(sendingData.length === 0){
      sendingData.push({
        fk_course_id: props.id,
        fk_testModules_id: undefined,
        fk_testSubModules_id: undefined,
      });
    }
    let cr = await createTestSeriesRelationByCourse(sendingData);
    if (cr?.status === 'success') {
      setPreSelectedIds(selectedSub)
      toast.success('test series course relation successfully created');
    }
    setLoading(false);
  };
  const handleModuleChange = async (e: any) => {
    //   if(e.removed){
    // let filteredList = fetchSubModuleList.filter((i:any) => i.mod !== e.removed);
    //   setFetchSubModuleList(filteredList);
    //   }
    //   if(e.selected.length === 0){
    //     setFetchSubModuleList([])
    //   }

    if (e.selected.length > 0) {
      if (e.removed) {
        let findExist = fetchAllList.filter((i: any) => i.value === e.removed);
        if (findExist.length > 0) {
          let filteredList = fetchSubModuleList.filter(
            (i: any) => i.mod !== e.removed
          );
          setFetchSubModuleList(filteredList);
        } else {
          fetchSubModuleData(e.selected[e.selected.length - 1]);
        }
      } else {
        fetchSubModuleData(e.selected[e.selected.length - 1]);
      }
    } else {
      setFetchSubModuleList([]);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className={`${fetchSubModuleList.length ===0  ? 'mb-[6rem]' : 'mb-5'}`}>
        <div className="mb-[1rem]">
          <MultiSearchableSelect
            name="modules"
            control={control}
            options={fetchAllList}
            label="Select Module"
            placeholder="Search.."
            onFetch={handleModuleChange}
          />
          {/* <MultiSearchableSelect
            name="sub_modules"
            control={control}
            options={fetchSubModuleList}
            rules={formValidationRules.required()}
            label="Select Sub Module"
            placeholder="Search.."
          /> */}
           {
                    loading ? <Loaders type='spinner' /> :
                    fetchSubModuleList.length > 0 &&
                    <>
                    <p>Select Sub Module</p>
                    <TreeMain trees={fetchSubModuleList} onFetch={setTreeData} preSelectedIds={preSelectedIds} />
                    <FormButton loading={loading} title={`Submit`} />
                    </>
                  }
        </div>
      </form>
    </>
  );
}
